export var SqlType;

(function (SqlType) {
  SqlType["BOOLEAN"] = "BOOLEAN";
  SqlType["TIMESTAMP"] = "TIMESTAMP";
  SqlType["DATE"] = "DATE";
  SqlType["INTERVAL"] = "INTERVAL";
  SqlType["TINYINT"] = "TINYINT";
  SqlType["SMALLINT"] = "SMALLINT";
  SqlType["INT"] = "INT";
  SqlType["BIGINT"] = "BIGINT";
  SqlType["DOUBLE"] = "DOUBLE";
  SqlType["REAL"] = "REAL";
  SqlType["DECIMAL"] = "DECIMAL";
  SqlType["FLOAT"] = "FLOAT";
  SqlType["NUMBER"] = "NUMBER";
  SqlType["CHAR"] = "CHAR";
  SqlType["VARCHAR"] = "VARCHAR";
  SqlType["STRING"] = "STRING";
  SqlType["BINARY"] = "BINARY";
  SqlType["ARRAY"] = "ARRAY";
  SqlType["MAP"] = "MAP";
  SqlType["STRUCT"] = "STRUCT";
  SqlType["JSON"] = "JSON";
  SqlType["T"] = "T";
  SqlType["COLREF"] = "COLREF";
})(SqlType || (SqlType = {}));